import { useState, useCallback } from "react";
import { screenStock, searchStocks } from "../services/api";

export function useScreener() {
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchResults, setSearchResults] = useState([]);
  const [searching, setSearching] = useState(false);

  const screen = useCallback(async (ticker) => {
    if (results[ticker]) return results[ticker]; // use cache

    setLoading(true);
    setError(null);
    try {
      const { data } = await screenStock(ticker);
      setResults((prev) => ({ ...prev, [ticker]: data }));
      return data;
    } catch (err) {
      setError(err.response?.data?.error || "Failed to screen stock");
      return null;
    } finally {
      setLoading(false);
    }
  }, [results]);

  const search = useCallback(async (query) => {
    if (!query || query.length < 2) {
      setSearchResults([]);
      return;
    }
    setSearching(true);
    try {
      const { data } = await searchStocks(query);
      setSearchResults(data.slice(0, 8));
    } catch {
      setSearchResults([]);
    } finally {
      setSearching(false);
    }
  }, []);

  return { screen, search, results, loading, error, searchResults, searching };
}
